import { GenerateManualStatementRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateGenerateManualStatement = makeValidator({
  FieldParser: GenerateManualStatementRow,
});
